// 1. jQuery를 먼저 로드
import $ from 'jquery';
// 2. jQuery noConflict 사용

// 3. 플러그인 로드
import 'jquery.easing';
//
// import gsap from 'gsap';
// import {ScrollTrigger} from 'gsap/ScrollTrigger';
//
// gsap.registerPlugin(ScrollTrigger);
// window.gsap = gsap;

$(document).ready(function () {
	/* Header */
	$('#header .gnb-list.pc .depth1').hover(
		function () {
			$(this).find('.depth2').fadeIn(150);
		},
		function () {
			$(this).find('.depth2').hide();
		},
	)

	let mobile = {
		leftOpen: function () {
			$('.mobile-inner').stop().animate({'right': '0'}, 400, 'easeInOutQuad');
		},

		leftClose: function () {
			$('.mobile-inner').stop().animate({'right': '200%'}, 400, 'easeInOutQuad');
		},

		rightOpen: function () {
			$('.mobile-inner').stop().animate({'right': '0'}, 400, 'easeInOutQuad');
			$("html").css('overflow', 'hidden');
		},

		rightClose: function () {
			$('.mobile-inner').stop().animate({'right': '-130%'}, 400, 'easeInOutQuad');
			$("html").css('overflow', 'auto');
		},

		slideOpen: function () {
			$('.mobile-inner').stop().slideDown(400, 'easeInOutQuad');
		},

		slideClose: function () {
			$('.mobile-inner').stop().slideUp(400, 'easeInOutQuad');
		},

		showOpen: function () {
			$('.mobile-inner').stop().fadeIn(0, 'easeInOutQuad');
		},

		showClose: function () {
			$('.mobile-inner').stop().fadeOut(0, 'easeInOutQuad');
		},

		down: function (target) {
			$(target).addClass('on');
			$(target).next().stop().slideDown(400, 'easeInOutQuad');

		},

		up: function (target) {
			$(target).removeClass('on');
			$(target).next().stop().slideUp(400, 'easeInOutQuad');
		},

		siblingsUp: function (target) {
			$(target).parent().siblings('li').children('a').removeClass('on');
			$(target).parent().siblings('li').children('ul').stop().slideUp(400, 'easeInOutQuad');
		},

		bgOn: function () {
			$('.gnb_bg').stop().fadeIn(400);
		},

		bgOff: function () {
			$('.gnb_bg').stop().fadeOut(400);
		}
	}

	let mobileInner = $('.mobile-inner');
	$('.mo-toggle').on('click', function () {
		$('.mo-toggle').toggleClass('active');
		if ($(this).hasClass('active')) {
			if (mobileInner.hasClass('left-move')) {
				mobile.leftOpen();
			} else if (mobileInner.hasClass('right-move')) {
				mobile.rightOpen();
			} else if (mobileInner.hasClass('slide-move')) {
				mobile.slideOpen()
			} else if (mobileInner.hasClass('show-move')) {
				mobile.showOpen()
			}
			mobile.bgOn();
		} else {
			if (mobileInner.hasClass('left-move')) {
				mobile.leftClose();
			} else if (mobileInner.hasClass('right-move')) {
				mobile.rightClose();
			} else if (mobileInner.hasClass('slide-move')) {
				mobile.slideClose()
			} else if (mobileInner.hasClass('show-move')) {
				mobile.showClose()
			}
			mobile.bgOff();
		}
	})

	$('.mobile-inner .depth1 > li > a').on('click', function () {
		mobile.siblingsUp(this);
		if ($(this).hasClass('on')) {
			mobile.up(this);
		} else {
			mobile.down(this);
		}
	});

	/* Popup */
	// 팝업 외부 클릭 감지 및 닫기
	$(document).on('mouseup', function (e) {
		var popup = $(e.target).closest(".popup");
		if (popup.length > 0 && popup.find(".popup-inner").has(e.target).length === 0) {
			var type = popup.attr('data-open-type') || 'normal';
			closePopup(popup, type);
		}
	});

	$('.top-btn').on('click', function () {
		$('html, body').stop().animate({'scrollTop': '0'});
	});

	/*------- sub -------*/
	const circleCursor = document.querySelector('.cursor-box');
	if (!circleCursor) return;

	let cursorX = 0;
	let cursorY = 0;
	let targetX = 0;
	let targetY = 0;
	const speed = 0.09; // 숫자가 작을수록 느리게 따라옴

	document.addEventListener('mousemove', (e) => {
		targetX = e.clientX;
		targetY = e.clientY;
	});

	function animateCursor() {
		cursorX += (targetX - cursorX) * speed;
		cursorY += (targetY - cursorY) * speed;
		circleCursor.style.left = `${cursorX}px`;
		circleCursor.style.top = `${cursorY}px`;

		requestAnimationFrame(animateCursor);
	}

	// animateCursor();


	if ($('#sub').length) {
		$('#header').addClass('sub_header');

		AOS.init();

		if ($('.tab-area').length) {
			const $links = $('.tab-area a');
			const $panels = $('.table-wrap, .dot-list[data-box]');

			$links.on('click', function () {
				const target = $(this).data('box');

				// 활성 클래스 처리
				$links.removeClass('on');
				$(this).addClass('on');

				// 박스 전환
				$panels.stop(true, true).hide();  // 모두 숨김
				$panels
				.filter(`[data-box="${target}"]`)
				.fadeIn(300); // 해당 박스만 fadeIn

				AOS.refresh();
			});
		}
	}
});

/* 삭제하지 말것 */
String.prototype.replaceAll = function (org, dest) {
	return this.split(org).join(dest);
}

// function refresh_captcha(){
//     document.getElementById("capt_img").src="/include/captcha.php?waste="+Math.random();
//     return false;
// }
